"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VNDialog = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));
var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));
var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _Box = _interopRequireDefault(require("@material-ui/core/Box"));
var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));
var _reactI18next = require("react-i18next");
var _VNButton = require("./VNButton");
var _VNTimeoutButton = require("./VNTimeoutButton");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    title: theme.typography.h2,
    subTitle: theme.typography.h3,
    header: {
      display: 'flex',
      justifyContent: 'center',
      height: '100%',
      alignItems: 'center',
      flexDirection: 'column'
    },
    buttonContainer: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%'
    }
  };
});

/**
 * A VN Dialog that pops up and provides an input field with cancel and save buttons.
 * @param {string} title - The title to display
 * @param {string} image - if title is not present use the image | SVG React Component
 * @param {string} subTitle - The subtitle to display
 * @param {string} label - The title to display above the input field
 * @param {bool} open - the state of the dialog if it is open or closed
 * @param {bool} showTextfield - If the input textfield should be shown
 * @param {object} rules - 
 * - validation: (val) => {} - called when the dialog wants to validate the input field
 * - showHelperText: (val) => {} - what helper text to show beneath the input field
 * - onBlur: (val) => {} - Called when you blur the input field, returns a value to set the input field
 * @param {string} startAdornment - If there is an adornment to display at the front
 * @param {func} onClose - Called when the dialog wants to close
 * @param {func} onSave - Called when the dialog is ready to save
 * @param {string} type - The type of input field you want: default is 'text'
 * @param {string} cancel - The cancel button text: default is T('CANCEL')
 * @param {string} save - The save button text: default is T('SAVE')
 * @param {boolean} fullWidth - sets the vndialog to the full width
 * @param {boolean} closeOnSave - call close function on save
 * @param {number} saveCountDownTime add a countdoown time for save.
 * @param {number} width override default width
 * @param {number} height override default height
 * @param {string} subtitleVariant override subtitle variant with another IE theme.typography.h5
 */
var VNDialog = function VNDialog(props) {
  var t = (0, _reactI18next.useTranslation)();
  var theme = (0, _styles.useTheme)();
  var classes = useStyles();

  // INTERNAL STATE

  // the current input of the dialog text
  var _useState = (0, _react.useState)(''),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    inputVal = _useState2[0],
    setInputVal = _useState2[1];

  // HANDLES

  // called on each character typed into the input field
  var onChange = function onChange(e) {
    if (props.rules && props.rules.validation) {
      if (props.rules.validation(e.target.value)) {
        setInputVal(e.target.value);
      }
    } else {
      setInputVal(e.target.value);
    }
  };

  // called when the save button is clicked
  var handleSave = function handleSave() {
    if (props.onSave(inputVal)) {
      props.onSave(inputVal);
    }
    if (!props.closeOnSave) {
      return;
    }
    if (props.onClose) {
      props.onClose();
    }
  };

  // called when cancel button is clicked
  var handleCancel = function handleCancel() {
    if (props.onClose) {
      props.onClose();
    }
  };

  // called on input blur
  var handleBlur = function handleBlur(event) {
    if (props.rules && props.rules.onBlur) {
      var newVal = props.rules.onBlur(event.target.value);
      setInputVal(newVal);
    }
  };

  // LOCAL FUNCTIONS

  // Get the limits for the text field
  var showHelperText = function showHelperText() {
    if (props.rules && props.rules.showHelperText) {
      return props.rules.showHelperText(inputVal);
    }
    return '';
  };

  // returns an error if the validation doesn't pass
  var getInputError = function getInputError() {
    if (props.rules && props.rules.validation) {
      return !props.rules.validation(inputVal);
    }
    return false;
  };
  var renderTitle = function renderTitle() {
    if (props.title) {
      return /*#__PURE__*/_react.default.createElement(_Typography.default, {
        className: classes.title,
        align: "center",
        id: "form-dialog-title"
      }, props.title.split("\n").map(function (i, key) {
        return /*#__PURE__*/_react.default.createElement("div", {
          key: key
        }, i);
      }));
    }
    if (props.image) {
      return props.image;
    }
  };
  var getStyle = function getStyle() {
    return (0, _objectSpread2.default)({}, theme.typography[props.subtitleVariant], {
      flex: 0,
      textAlign: 'center',
      fontWeight: 500
    });
  };
  return /*#__PURE__*/_react.default.createElement(_Dialog.default, {
    fullWidth: props.fullWidth,
    open: props.open,
    PaperProps: {
      style: {
        backgroundColor: theme.custom.colors.backgroundColor,
        width: props.width ? props.width : theme.custom.defaultDialog.width,
        height: props.height ? props.height : theme.custom.defaultDialog.height,
        display: 'flex',
        justifyContent: 'flex-end',
        flexDirection: 'column'
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_Box.default, {
    className: classes.header
  }, /*#__PURE__*/_react.default.createElement(_Box.default, {
    pb: 3,
    pt: 1,
    width: '100%'
  }, renderTitle()), /*#__PURE__*/_react.default.createElement(_DialogContent.default, {
    style: {
      flex: 0,
      overflowY: 'inherit'
    }
  }, props.subTitle && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: classes.subTitle,
    style: getStyle()
  }, props.subTitle.split("\n").map(function (i, key) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: key
    }, i);
  })), props.showTextfield && /*#__PURE__*/_react.default.createElement(_TextField.default, {
    error: getInputError(),
    autoFocus: true,
    multiline: true,
    margin: "dense",
    id: "vndialog",
    label: props.label,
    type: props.type ? props.type : 'text',
    fullWidth: true,
    value: inputVal,
    onChange: onChange,
    helperText: showHelperText(),
    onBlur: handleBlur,
    style: {
      color: theme.custom.colors.mainTextColor,
      background: theme.custom.colors.greyMedium
    },
    InputProps: {
      startAdornment: /*#__PURE__*/_react.default.createElement(_InputAdornment.default, {
        position: "start"
      }, props.startAdornment ? props.startAdornment : '')
    }
  }))), /*#__PURE__*/_react.default.createElement(_Box.default, {
    className: classes.buttonContainer
  }, /*#__PURE__*/_react.default.createElement(_DialogActions.default, {
    style: (0, _objectSpread2.default)({}, theme.custom.buttonContainer)
  }, props.cancel && /*#__PURE__*/_react.default.createElement(_VNButton.VNButton, {
    onClick: handleCancel,
    buttonVariant: 'button5',
    color: "primary",
    text: props.cancel
  }), props.saveCountDownTime ? /*#__PURE__*/_react.default.createElement(_VNTimeoutButton.VNTimeoutButton, {
    buttonVariant: 'button5',
    text: props.save,
    onClick: handleSave,
    countdownTime: props.saveCountDownTime,
    color: "primary"
  }) : /*#__PURE__*/_react.default.createElement(_VNButton.VNButton, {
    onClick: handleSave,
    buttonVariant: 'button5',
    color: "primary",
    text: props.save,
    disabled: getInputError()
  }))));
};
exports.VNDialog = VNDialog;